/**
 * MOBILE DETECTION HOOK
 * =====================
 * 
 * This hook detects whether the user is on a mobile device
 * based on screen width. It's responsive and updates when
 * the window is resized.
 * 
 * Usage:
 * const isMobile = useMobile();
 */

import { useState, useEffect } from "react"

const MOBILE_BREAKPOINT = 1024

export function useMobile() {
  const [isMobile, setIsMobile] = useState<boolean>(false)

  useEffect(() => {
    // Some embedded webviews ship without matchMedia. Without the listener the
    // value stops tracking resizes, which is a far smaller loss than throwing
    // out of this effect and unmounting the app.
    const mql =
      typeof window.matchMedia === "function"
        ? window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
        : null

    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }

    // Set initial value
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)

    // Listen for changes
    mql?.addEventListener("change", onChange)

    return () => mql?.removeEventListener("change", onChange)
  }, [])

  return isMobile
}